export default {
  all: {
    results: []
  }
}
